import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Profiles Redux States
import {
  GET_PROFILES,
  CREATE_PROFILES,
  GET_PROFILE,
  EDIT_PROFILE,
  DELETE_PROFILE,
} from "./actionTypes";
import {
  loadProfiles,
  apiError,
  createdProfile,
  setProfile,
  editProfileSuccess,
  deleteProfileSuccess,
} from "./actions";
//Include Both Helper File with needed methods
import axios from "axios";

function* getProfiles({ payload: { page, qnt, name, description } }) {
  try {
    const response = yield call(
      axios.get,
      `/profile${
        (page ? `?page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (description ? `&description=${description}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(loadProfiles(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* createProfile({ payload: { newProfileValues } }) {
  try {
    const response = yield call(axios.post, `/profile`, newProfileValues);
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      let message = response.data.message;
      yield put(createdProfile(newProfileValues, message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getProfile({ payload: { idProfile, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/profile?${
        (idProfile ? `&id=${idProfile}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setProfile(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editProfile({ payload: { idProfile, newProfileValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/profile${idProfile ? `?id=${idProfile}` : ""}`,
      newProfileValues
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(editProfileSuccess({ newProfileValues, message }));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteProfile({ payload: { idProfile } }) {
  try {
    const response = yield call(
      axios.delete,
      `/profile${idProfile ? `?id=${idProfile}` : ""}`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteProfileSuccess(idProfile, message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Profile not found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchProfile() {
  yield takeEvery(GET_PROFILES, getProfiles);
}
export function* watchCreateProfile() {
  yield takeEvery(CREATE_PROFILES, createProfile);
}
export function* watchGetProfile() {
  yield takeEvery(GET_PROFILE, getProfile);
}
export function* watchEditProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile);
}
export function* watchDeleteProfile() {
  yield takeEvery(DELETE_PROFILE, deleteProfile);
}
function* authSaga() {
  yield all([
    fork(watchProfile),
    fork(watchCreateProfile),
    fork(watchGetProfile),
    fork(watchEditProfile),
    fork(watchDeleteProfile),
  ]);
}

export default authSaga;
